var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import WalletService from '../../api/WalletService';
import { Loading } from 'element-ui';
import Header from './components/Header.vue';
var PayRecord = (function (_super) {
    __extends(PayRecord, _super);
    function PayRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        return _this;
    }
    PayRecord.prototype.created = function () {
        this.service = WalletService.getInstance();
    };
    PayRecord.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.getList();
    };
    PayRecord.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    PayRecord.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getLogList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data;
            _this.listData = DATA.data;
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PayRecord.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PayRecord = __decorate([
        Component({
            components: {
                'list-header': Header
            }
        })
    ], PayRecord);
    return PayRecord;
}(Vue));
export default PayRecord;
